const product = {
  // Features - Optics
  p2_optics_title: 'Powerful, Hidden in the Tiny',
  p2_optics_sub: 'STRENGTH LIES IN THE SMALL.',
  p2_optics_badge1_zh: 'Ultra-Compact Engine',
  p2_optics_badge2_zh: 'High Brightness',
  p2_optics_badge3_zh: 'Visible Outdoors',
  p2_optics_body: 'Crystal-clear display technology packed into a space the size of a grain of rice. NIMO\'s 0.03cc ultra-compact optical engine delivers 1500 nits of brightness — sharp and vivid even under the intense midday sun.',

  // Features - Materials
  p2_mat_title: 'The screen lives in the lens,\nbut you can\'t see it.',
  p2_mat_sub: 'THE SCREEN IS INSIDE THE LENS\nBUT YOU CAN\'T SEE IT.',
  p2_mat_body: 'This is the art of optics. Advanced binocular volume holographic waveguide technology achieves an astonishing 98% light transmittance. The world stays clear and real — no "screen" barrier. A unique optical path ensures only you can see the display, protecting your privacy completely.',
  p2_mat_b1_zh: 'Binocular Holographic Waveguide',
  p2_mat_b2_zh: 'Zero Visual Leakage',
  p2_stat1_zh: 'Ultra-High Transmittance',
  p2_stat1_desc: 'Binocular holographic waveguide — the world stays clear, the display is yours alone.',
  p2_stat2_zh: 'HD Clarity',
  p2_stat2_desc: 'Clearly visible in bright sunlight. Sharp detail, no visual compromise.',
  p2_stat3_zh: 'Zero Leakage to Others',
  p2_stat3_desc: 'Unique optical path ensures only you see the display — full privacy protection.',

  // Specs
  p2_specs_label: 'Full Specifications',
  p2_specs_title: 'Technical Specs',
  p2_specs_sub: 'Every parameter comes from real engineering data. Every detail refined through repeated iteration.',
  p2_spec_cat1: 'Micro Optical Engine',
  p2_spec_cat2: 'Waveguide',
  p2_spec_cat3: 'Materials & Structure',
  p2_spec_cat4: 'Wireless',
  p2_spec_cat5: 'Productivity',
  p2_spec_cat6: 'Battery & Lenses',
  p2_spec_l1_1: 'Engine Volume', p2_spec_v1_1: '0.03cc',
  p2_spec_l1_2: 'Eye Brightness', p2_spec_v1_2: '1500 nits',
  p2_spec_l1_3: 'Resolution', p2_spec_v1_3: '540 × 280',
  p2_spec_l2_1: 'Technology', p2_spec_v2_1: 'Volume Holographic Waveguide',
  p2_spec_l2_2: 'Transmittance', p2_spec_v2_2: '98%',
  p2_spec_l2_3: 'FOV', p2_spec_v2_3: '28°',
  p2_spec_l3_1: 'Frame Material', p2_spec_v3_1: 'Carbon Fiber',
  p2_spec_l3_2: 'Temple Material', p2_spec_v3_2: 'β-Titanium',
  p2_spec_l3_3: 'Total Weight', p2_spec_v3_3: '~29g',
  p2_spec_l4_1: 'Wireless Sync', p2_spec_v4_1: 'Dual-Sync',
  p2_spec_l4_2: 'Platforms', p2_spec_v4_2: 'Android, iOS',
  p2_spec_l4_3: 'Protocol', p2_spec_v4_3: 'Bluetooth 5.2',
  p2_spec_l5_1: 'Translation Latency', p2_spec_v5_1: '< 1 sec',
  p2_spec_l5_2: 'Recognition Accuracy', p2_spec_v5_2: '95%+',
  p2_spec_l5_3: 'Protection Rating', p2_spec_v5_3: 'IP54',
  p2_spec_l6_1: 'Battery Life', p2_spec_v6_1: '24–48H depending on usage',
  p2_spec_l6_2: 'Charge Time', p2_spec_v6_2: 'Full charge in 25 min',
  p2_spec_l6_3: 'Operating Temp', p2_spec_v6_3: '-10°C to 50°C',

  // Hero - top banner
  p2_hero_title: 'NIMO Smart Glasses',
  p2_hero_sub: 'Perceptual Evolution · Total Immersion',
  p2_hero_desc: 'The next generation NIMO Smart Glasses — binocular holographic waveguide display fused with on-device AI. 1500 nits brightness, all-day battery, ultra-light frame.',

  // Hero - slides
  p2_s1_title: 'Wear It,\nSee a New World.',
  p2_s1_f1: 'Immersive Digital Experience',
  p2_s1_f2: 'All-Scenario AI Empowerment',
  p2_s1_desc: 'Whether navigating busy city streets or immersed in cross-border meetings, NIMO opens a new visual dimension for you. Navigation, real-time translation, notifications — all digital information seamlessly fused with reality.',
  p2_s2_title: 'Light as a Feather,\nTechnology Invisible.',
  p2_s2_f1: 'Ultra-Light 29g Frame',
  p2_s2_f2: 'All-Day Comfort Wear',
  p2_s2_desc: 'Built on an aerospace-grade titanium skeleton, redefining the weight boundary of smart wearables. Just 29g, with a precisely tuned 5:5 front-to-back balance — the glasses feel like an extension of your body, from dawn to midnight.',
  p2_s3_title: '1500 Nits,\nClearly Visible.',
  p2_s3_f1: 'Binocular Waveguide Display',
  p2_s3_f2: 'Visible in Direct Sunlight',
  p2_s3_desc: 'Our proprietary binocular waveguide display system delivers peak brightness of 1500 nits — sharp and vivid even under intense direct sunlight. On-device AI renders every frame precisely in the center of your vision.',
  p2_s4_title: 'Thoughts Converge,\nFlow Arises.',
  p2_s4_f1: 'On-Device AI Inference',
  p2_s4_f2: 'Real-Time Info Awareness',
  p2_s4_desc: 'Built-in on-device AI completes intelligent inference and response without internet. From schedule reminders to instant translation, from context awareness to personalized assistant — NIMO integrates AI into your daily life.',

  // Hero - light section
  p2_light_title: 'Wear It All Day, Feel Nothing.',
  p2_light_sub: 'Wearing it all day feels like wearing nothing.',
  p2_light_body: 'Pushing the boundaries of craftsmanship to give you the lightest wearing experience. Weighing just 29g, with a meticulously tuned 50:50 front-to-back weight distribution, the glasses rest firmly on your ears — completely relieving nose bridge pressure.',
  p2_light_s1: 'Ultra-Light AI Smart Glasses',
  p2_light_s2: 'Zero Nose Bridge Pressure',
  p2_light_s3: '5:5 Golden Weight Balance',

  // Hero - vision section
  p2_vision_title: 'See a Wider World.',
  p2_vision_sub: 'See a world beyond what the eye can reach.',
  p2_vision_body: 'Binocular waveguide display with 1500 nits peak brightness — crystal clear in any lighting condition. On-device AI processes everything in real time: navigation, translation, notifications — all at your fingertips.',
  p2_vision_s1: 'Full-Color Waveguide',
  p2_vision_s2: '1500 Nits Brightness',
  p2_vision_s3: 'On-Device AI Processing',

  // CTA
  p2_cta_label: 'NIMO Smart Glasses 2',
  p2_cta_title: 'Experience It Early',
  p2_cta_title2: 'The Next Step in Perceptual Evolution',
  p2_cta_color_label: 'Color',
  p2_cta_color1: 'Midnight Black',
  p2_cta_color2: 'Moonlight White',
  p2_cta_desc: 'Smart Glasses 2 is now accepting early experience applications. Join the NIMO Early Access program for priority purchase rights and exclusive benefits.',
  p2_cta_btn1: 'Reserve Experience →',
  p2_cta_btn2: 'Back to Home',
  p2_cta_disclaimer: 'Product specifications and design may vary in the final production version · Official release information prevails',
};

export default product;
